import kyWithSentry from './helper/kyWithSentry';
import { EntityTypes } from 'context/entityContext';
import getLinkfireActivityTrendUrl from 'url-constructors/Linkfire/getLinkfireActivityTrendURL';

export interface ILinkfireActivityTrendArgs {
  entityType: EntityTypes;
  entityIds: string[];
  period?: string;
  dateFrom?: string;
  dateTo?: string;
}

interface IResponseObj {
  artistId: string;
  stores: { data: any[] }[];
}

const linkfireActivityTrendInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData: ILinkfireActivityTrendArgs
): Promise<Response> => {
  try {
    const trendUrl = getLinkfireActivityTrendUrl(interceptionData);
    const resp: IResponseObj[] = await kyWithSentry.get(trendUrl).json();
    const response = {
      trendRawData:
        resp && resp.length > 0 && resp[0].stores && resp[0].stores.length > 0
          ? resp[0].stores[0].data
          : null,
    };
    return new Response(JSON.stringify(response));
  } catch (error) {
    const errorInfo = await error.response.json();
    return new Response(
      JSON.stringify({
        reason: {
          message: errorInfo.message,
        },
      })
    );
  }
};

export default linkfireActivityTrendInterceptor;
